// extracted by mini-css-extract-plugin
export default {"title":"QsTGG","links":"LpCYY","greaterThan":"CxXfy","subscribeBtn":"EsuRn","search":"_UIpQ"};